function encodeUid(value) {
  if (process.server) {
    const str = Buffer.from(`${value}`, "utf-8");
    return str.toString("base64");
  } else {
    if (window && "btoa" in window) {
      return window.btoa(`${value}`);
    }
  }
  return null;
}
function decodeUid(value) {
  if (process.server) {
    const str = Buffer.from(value, "base64");
    return str.toString("utf-8");
  } else {
    if (window && "atob" in window) {
      return window.atob(value);
    }
  }
  return null;
}
export {
  decodeUid,
  encodeUid
};
